import type { PublicToolCategorySlug } from '@/lib/tool-categories';

// Short chip labels + display order for the catalog filter row. Kept in its own
// tiny, dependency-free module so both the client catalog (ToolAppCatalog) and the
// SSR fallback (ToolCatalogFallback) can import it without pulling the heavy
// tools.ts/tool-categories.ts graph into the client bundle (the type import is
// erased at build). Full category titles live in tool-categories.ts; these are the
// space-constrained chip versions.
export const CATEGORY_CHIP_ORDER: PublicToolCategorySlug[] = [
  'image-tools',
  'format-icon-tools',
  'photo-cleanup-tools',
  'pdf-tools',
  'video-tools',
  'gif-editor',
  'audio-tools',
  'css-design-tools',
  'developer-tools',
  'data-tools',
  'calculators',
  'text-tools',
  'time-tools',
  'generator-tools',
  'web-seo-tools',
  'unit-converters',
  'privacy-tools',
  'seller-tools',
  'ai-workflows',
];

export const CATEGORY_CHIP_LABELS: Record<PublicToolCategorySlug, string> = {
  'image-tools': 'Image',
  'format-icon-tools': 'Icons',
  'photo-cleanup-tools': 'Cleanup',
  'pdf-tools': 'PDF',
  'video-tools': 'Video',
  'gif-editor': 'GIF',
  'audio-tools': 'Audio',
  'css-design-tools': 'CSS',
  'developer-tools': 'Dev',
  'data-tools': 'Data',
  calculators: 'Calc',
  'text-tools': 'Text',
  'time-tools': 'Time',
  'generator-tools': 'Generators',
  'web-seo-tools': 'SEO',
  'unit-converters': 'Units',
  'privacy-tools': 'Privacy',
  'seller-tools': 'Seller',
  'ai-workflows': 'AI',
};
